<template>
  <div :style="wrapperStyle">
    <div
      style="
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -40%);
      "
    >
      {{ initials }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
  },
  computed: {
    initials: function () {
      return this.name
        ? this.name
            .split(" ")
            .map((n) => n[0])
            .join("")
        : "";
    },

    wrapperStyle: function () {
      return {
        display: "inline-block",
        verticalAlign: "middle",
        position: "relative",
        backgroundColor: this.initials
          ? this.colors[this.initials[0]]
          : "rgb(0,0,0, .3)",
        color: "#FFF",
        borderRadius: "50%",
        height: "40px",
        width: "40px",
      }
      }

  },
  data() {
    return {
      colors: {
        A: "#DBD56E",
        B: "#08605F",
        C: "#FF8CC6",
        D: "#DE369D",
        E: "#6F5E76",
        F: "#7C6354",
        G: "#648DE5",
        H: "#304C89",
        I: "#443850",
        J: "#59C3C3",
        K: "#CFCFEA",
        L: "#A89B9D",
        M: "#816C61",
        N: "#575A4B",
        O: "#2A2C24",
        P: "#5D2E8C",
        Q: "#2EC4B6",
        R: "#73628A",
        S: "#313D5A",
        T: "#183642",
        U: "#007C77",
        V: "#18A999",
        W: "#109648",
        X: "#EBCFB2",
        Y: "#035E7B",
        Z: "#66D7D1",
      },
    };
  },
  methods: {},
};
</script>